var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { ChildProperty, Collection, Event, Property } from '@syncfusion/ej2-base';
import { Item } from '@syncfusion/ej2-splitbuttons';
/**
 * Defines the ribbon DropDownButton item.
 */
export class RibbonDropDownSettings extends ChildProperty {
    /**
     * @param {Object} prop - Gets the property of DropDown.
     * @param {boolean} muteOnChange - Gets the boolean value of muteOnChange.
     * @returns {void}
     * @private
     */
    setProperties(prop, muteOnChange) {
        super.setProperties(prop, muteOnChange);
    }
}
__decorate([
    Property('')
], RibbonDropDownSettings.prototype, "closeActionEvents", void 0);
__decorate([
    Property('')
], RibbonDropDownSettings.prototype, "content", void 0);
__decorate([
    Property('')
], RibbonDropDownSettings.prototype, "cssClass", void 0);
__decorate([
    Property('')
], RibbonDropDownSettings.prototype, "iconCss", void 0);
__decorate([
    Collection([], Item)
], RibbonDropDownSettings.prototype, "items", void 0);
__decorate([
    Property('')
], RibbonDropDownSettings.prototype, "target", void 0);
__decorate([
    Property(false)
], RibbonDropDownSettings.prototype, "createPopupOnClick", void 0);
__decorate([
    Property({})
], RibbonDropDownSettings.prototype, "htmlAttributes", void 0);
__decorate([
    Event()
], RibbonDropDownSettings.prototype, "beforeClose", void 0);
__decorate([
    Event()
], RibbonDropDownSettings.prototype, "beforeItemRender", void 0);
__decorate([
    Event()
], RibbonDropDownSettings.prototype, "beforeOpen", void 0);
__decorate([
    Event()
], RibbonDropDownSettings.prototype, "close", void 0);
__decorate([
    Event()
], RibbonDropDownSettings.prototype, "created", void 0);
__decorate([
    Event()
], RibbonDropDownSettings.prototype, "open", void 0);
__decorate([
    Event()
], RibbonDropDownSettings.prototype, "select", void 0);
